import * as inflected from 'inflected'

const LOWERCASE_WORDS = ['of', 'from', 'a', 'to', 'the']

export const capitalize = string => {
  const words = string.split(/\s+/g)

  return words
    .map((word, i) => {
      if (
        LOWERCASE_WORDS.includes(word.toLowerCase()) &&
        i !== 0 &&
        i !== words.length - 1
      ) {
        return word.toLowerCase()
      } else {
        return `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`
      }
    })
    .join(' ')
    .trim()
}

export const titleize = string => {
  return inflected.titleize(inflected.humanize(inflected.underscore(string)))
}

export const sameToken = (char1, char2) => {
  // Second character is capitalized
  if (char2.match(/[A-Z]/)) {
    return false
  }

  // one character is number
  if (
    (char1.match(/\d/) && !char2.match(/\d/)) ||
    (char2.match(/\d/) && !char1.match(/\d/))
  ) {
    return false
  }

  return true
}

export const humanize = (string = '') => {
  // snake_case or dash-case
  let snakeWords = string.split(/[\-_]/g)
  let result = snakeWords.join(' ')

  // CamelCase
  let words = []
  let currentWord = result.slice(0, 1)

  for (let i = 1; i < result.length; i += 1) {
    if (!sameToken(result.slice(i - 1, i), result.slice(i, i + 1))) {
      words.push(currentWord)
      currentWord = result[i]
    } else {
      currentWord += result[i]
    }
  }

  words.push(currentWord)

  result = words.join(' ')

  // Replace multiple spaces
  result = result.replace(/\s+/g, ' ').trim()

  return result
}
